import { createFileRoute, notFound } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { seoMeta } from "@/lib/seo/head";
import { getGlossaryEntry, GLOSSARY } from "@/lib/seo/glossary";
import { JsonLd, definedTermSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/glossario/$slug")({
  loader: ({ params }) => {
    const entry = getGlossaryEntry(params.slug);
    if (!entry) throw notFound();
    return { entry };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: "Glossario - LexAIPro" }] };
    const base = loaderData.entry.short.replace(/\.$/, "");
    const description = `${base} — voce del glossario di intelligenza artificiale legale di LexAIPro.`;
    return seoMeta({
      title: `${loaderData.entry.term} - Glossario LexAIPro`,
      description,
      path: `/glossario/${loaderData.entry.slug}`,
      type: "article",
    });
  },
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground">Voce non trovata.</p>
    </div>
  ),
  errorComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground">Errore nel caricamento.</p>
    </div>
  ),
  component: GlossaryEntryPage,
});

function GlossaryEntryPage() {
  const { entry } = Route.useLoaderData();
  const related = GLOSSARY.filter((g) => g.slug !== entry.slug).slice(0, 4);
  return (
    <>
      <JsonLd data={definedTermSchema({ name: entry.term, description: entry.short, path: `/glossario/${entry.slug}` })} />
      <ContentPage
        eyebrow="Glossario"
        title={entry.term}
        lead={entry.short}
        breadcrumbs={[{name:"Home",path:"/"},{name:"Glossario",path:"/glossario"},{name:entry.term,path:`/glossario/${entry.slug}`}]}
        sections={[
          { heading: "Definizione estesa", body: entry.body },
          { heading: "Voci correlate", bullets: related.map((r) => `${r.term} - ${r.short}`) },
        ]}
        cta={{ label: "Prova LexAIPro", to: "/signup" }}
        updated="2026"
      />
    </>
  );
}
